import React, {FC, ReactNode} from 'react';
import {observer} from 'mobx-react-lite';
import * as antd from 'antd';
import {List} from 'antd';

export type PaginationViewModel = {
    currentPage: number;
    totals: number;
    itemsPerPage?: number;
    setCurrentPage: (page: number) => void;
    range: number[];
};

interface PaginationProps {
    model: PaginationViewModel;
    hidePages?: boolean;
    action?: ReactNode;
}

export const Pagination: FC<PaginationProps> = observer(({model, action, hidePages}) => {
    return (
        <List itemLayout={'horizontal'} className="list horizontal" split={false}>
            <List.Item className="item">
                {<span>{`${model.range[0]}-${model.range[1]} of ${model.totals} auctions`}</span>}
            </List.Item>
            <List.Item className="item">{action}</List.Item>
            <List.Item className="item">
                {model.itemsPerPage && (
                    <antd.Pagination
                        className={hidePages ? 'pagination-hide-numbers' : ''}
                        onChange={model.setCurrentPage}
                        total={model.totals}
                        showSizeChanger={false}
                        pageSize={model.itemsPerPage}
                        current={model.currentPage}
                    />
                )}
            </List.Item>
        </List>
    );
});
